import { render, staticRenderFns } from "./SelectDeck.vue?vue&type=template&id=135fff5a&scoped=true"
import script from "./SelectDeck.vue?vue&type=script&lang=js"
export * from "./SelectDeck.vue?vue&type=script&lang=js"
import style0 from "./SelectDeck.vue?vue&type=style&index=0&id=135fff5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fff5a",
  null
  
)

export default component.exports